import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { apiPost } from '@/lib/api';
import { useAuthStore } from '@/lib/auth';

export function useLogout() {
  const signOut = useAuthStore((s) => s.signOut);
  const qc = useQueryClient();
  const navigate = useNavigate();
  return useMutation({
    mutationFn: async () => {
      try {
        await apiPost<void>('/v1/auth/logout');
      } catch {
        // Even if the call fails (e.g. token already expired), proceed with local sign-out.
      }
    },
    onSettled: () => {
      signOut();
      qc.clear();
      void navigate({ to: '/login' });
    },
  });
}
